<template>
  <el-dialog
    custom-class="dialog-component"
    v-bind="$attrs"
    :title="title"
    v-on="$listeners"
  >
    <div class="body-box">
      <slot />
    </div>
    <template #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss">
.dialog-component {
  min-width: 880px;

  .body-box {
    height: 420px;
    overflow: auto;
  }
}
</style>
